import _ from 'lodash'
import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { NeurologicWeaknessItem } from '@fusion-advantage/formlib'

export interface NeurologicWeaknessReviewSliceState {
	selectedHumanoidSite: string|null,
	currentModel: NeurologicWeaknessItem | null,
	models: NeurologicWeaknessItem[],
	showDialog: boolean,
}

const initialState: NeurologicWeaknessReviewSliceState = {
	selectedHumanoidSite: null,
	currentModel: null,
	models: [],
	showDialog: false,
}

const NeurologicWeaknessReviewSlice = createSlice({
	name: 'neurologicWeaknessReview',
	initialState,
	reducers: {
		setNeurologicWeaknessReview(state, action: PayloadAction<NeurologicWeaknessItem[]>) {
			state.models = action.payload
		},
		setNeurologicCurrentModel(state, action: PayloadAction<NeurologicWeaknessItem|null>) {
			state.currentModel = action.payload
		},
		setNeurologicSelectedHumanoidSite(state, action: PayloadAction<string|null>) {
			state.selectedHumanoidSite = action.payload
		},
		setNeurologicShowDialog(state, action: PayloadAction<boolean>) {
			state.showDialog = action.payload
		},
	},
})

export const {
	setNeurologicWeaknessReview,
	setNeurologicCurrentModel,
	setNeurologicSelectedHumanoidSite,
	setNeurologicShowDialog
} = NeurologicWeaknessReviewSlice.actions

export default NeurologicWeaknessReviewSlice.reducer